<h2 padding *ngIf="config.firstInGroup && config.widgetGroup !== null" [innerHTML]="i18n({ translate: 'widgetGroup', fallback: config.widgetGroup.label })">

</h2>
